/**
 * External dependencies
 */
import React, { useState } from 'react';
import { Box, Text, Stack, Divider } from '@towersystems/towersystems-design-system';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import PopoverMenu from 'components/popover/menu';
import Item from './item';
import Icon from 'components/icon';
import { getCurrentUsername } from 'state/current-user/selectors';

/**
 * Style dependencies
 */
import './styles.scss';

const UserMenuDropdown = (props) => {
    const [isMenuVisible, setIsMenuVisible] = useState(false);

    const handleClick = () => {
        setIsMenuVisible(!isMenuVisible);
    };

    return (
        <PopoverMenu
            className='user-menu-dropdown'
            enterExitTransitionDurationMs={50}
            onOuterAction={() => setIsMenuVisible(false)}
            isOpen={isMenuVisible}
            showArrow={true}
            content={
                <Box className='user-menu-dropdown__content' justifyContent='start' padding='medium'>
                    <Item path='/logout' label='Logout' icon='FiLogOut' />
                </Box>
            }
        >
            <Box>
                <button className='topbar__gravatar-btn' onClick={handleClick}>
                    <Box display='flex' alignItems='center'>
                        <Box marginLeft='medium'>
                            <Text size='small' weight='medium'>
                                <Icon name='BiUser' type='bi' marginRight={5} style={{ fontSize: 20 }} />
                                {props.username}
                            </Text>
                        </Box>
                        <Icon name='GrFormDown' type='gr' />
                    </Box>
                    
                </button>
            </Box>
        </PopoverMenu>
    );
};

export default connect((state) => ({
    username: getCurrentUsername(state),
}))(UserMenuDropdown);
